import get from 'lodash/get';
import { MODE, MESSAGE_COPY, MESSAGE_ACTION_COPY } from '../constants';
import { getFieldsWithSuggestions } from '../helpers';

/**
 * showMessage
 * Helper function that validates whether to show a message
 */
export const showMessage = (props) => get(props, 'undefinedFields', []).length > 0;

/**
 * getHandleCancelState
 * Helper function that gets the correct state for handleCancel
 */
export const getHandleCancelState = () => {
  return { viewMode: MODE.view, fields: {} };
};

/**
 * getHandleEnterConfirmMode
 * Helper function that gets the correct state for handleEnterConfirmMode
 */
export const getHandleEnterConfirmMode = () => {
  return { viewMode: MODE.confirm };
};

/**
 * getHandleEnterDefineModeState
 * Helper function that gets the correct state for handleEnterDefineMode
 */
export const getHandleEnterDefineModeState = (props, state) => {
  const { rows } = props;
  const { fields } = state;
  const { suggestedTypes, updatedFields } = getFieldsWithSuggestions({ rows, fields });
  return {
    viewMode: MODE.define,
    suggestedTypes,
    fields: updatedFields,
  };
};

/**
 * getMessageContent
 * Helper function that gets the correct message content to display
 */
export const getMessageContent = (props, state) => {
  const { undefinedFields } = props;
  const { viewMode } = state;
  switch (viewMode) {
    case MODE.view:
      return MESSAGE_COPY[MODE.view](undefinedFields.length);
    case MODE.define:
    case MODE.confirm:
      return MESSAGE_COPY[viewMode];
    default:
      return '';
  }
};

/**
 * getMessageActionText
 * Helper function that gets the correct message action text to display
 */
export const getMessageActionText = (state) => {
  const { viewMode } = state;
  switch (viewMode) {
    case MODE.view:
    case MODE.define:
    case MODE.confirm:
      return MESSAGE_ACTION_COPY[viewMode];
    default:
      return '';
  }
};

/**
 * getFooterAction
 * Helper function that gets the correct message action text to display
 */
export const getFooterAction = () => {
  const { viewMode } = this.state;
  return viewMode === MODE.define ? this.handleCancel() : this.handleEnterDefineMode();
};
